import { render } from "./Total.vue?vue&type=template&id=2e021eb2&scoped=true"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"

import "./Total.vue?vue&type=style&index=0&id=2e021eb2&lang=scss&scoped=true"

import exportComponent from "/Users/malik/Sites/ismatgroup-satisfaction/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e021eb2"]])

export default __exports__